import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useState } from 'react'
import { isMobileOnly } from 'react-device-detect'
import {
  ExportCompanyAbsencesCard,
  ExportCompanyIssuesCard,
  ExportDriverActivitiesCard,
  ExportInfringementsCard,
  ExportTimesheetsCard,
} from '../components'
import { InfoBox, SettingsWrapper } from '../components/common'
import { useModuleConfigs } from '../hooks'
import { ExportUnknownDriverLocations } from '../components/ExportsSettings/ExportUnknownDriverLocations'

interface ExportsSettingsSettingsProps {}

export const ExportsSettings: React.FC<ExportsSettingsSettingsProps> = () => {
  const translations = useTranslate({
    info1: 'settings.info.exports-1',
  })

  const [loading, setLoading] = useState(false)

  function handleLoadingChanged(formLoading: boolean) {
    setLoading(formLoading)
  }

  const { active } = useModuleConfigs()

  return (
    <SettingsWrapper
      grid={{
        flow: 'row',
      }}
    >
      <InfoBox initCollapsed={isMobileOnly}>
        <p>{translations.info1}</p>
      </InfoBox>

      {active.activities && (
        <>
          <ExportDriverActivitiesCard
            loading={loading}
            onLoadingChangedCallback={handleLoadingChanged}
          />
          <ExportUnknownDriverLocations
            loading={loading}
            onLoadingChangedCallback={handleLoadingChanged}
          />
        </>
      )}

      {active.issues && (
        <ExportCompanyIssuesCard
          loading={loading}
          onLoadingChangedCallback={handleLoadingChanged}
        />
      )}

      {active.infringements && (
        <ExportInfringementsCard
          loading={loading}
          onLoadingChangedCallback={handleLoadingChanged}
        />
      )}

      {active.timesheets && (
        <ExportTimesheetsCard
          loading={loading}
          onLoadingChangedCallback={handleLoadingChanged}
        />
      )}

      {active.absences && (
        <ExportCompanyAbsencesCard
          loading={loading}
          onLoadingChangedCallback={handleLoadingChanged}
        />
      )}
    </SettingsWrapper>
  )
}
